"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validate;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _isValidUrl = _interopRequireDefault(require("../../../../helpers/isValidUrl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function validate(values) {
  var errors = {};
  var defaultBranch = (0, _get2["default"])(values, 'branchedCompletionConfig.defaultBranch', {});
  checkBranch(defaultBranch, 'defaultBranch', errors);
  var branches = (0, _get2["default"])(values, 'branchedCompletionConfig.branches', []);
  if (branches.length) {
    branches.forEach(function (b, i) {
      checkBranch(b, "branch.".concat(i), errors);
    });
  }
  return errors;
}
function checkBranch(branch, errorIndex, errors) {
  if (branch.action === 'message' && !branch.completionMessage) {
    (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".completionMessage"), 'Message is required');
  }
  var conditions = (0, _get2["default"])(branch, 'conditions', []);
  conditions.forEach(function (c, i) {
    if (c.action === 'url') {
      if (!c.completionUrl) {
        (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".conditions.").concat(i, ".completionUrl"), 'URL is required');
      } else if (!(0, _isValidUrl["default"])(c.completionUrl)) {
        (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".conditions.").concat(i, ".completionUrl"), 'URL is invalid');
      }
    }
    if (c.action === 'dcwRedirect') {
      if (!c.completionDcw) {
        (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".conditions.").concat(i, ".completionDcw"), 'DCW selection is required');
      }
    }
    if (conditions.length > 1) {
      if (!c.conditionName) {
        (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".conditions.").concat(i, ".conditionName"), 'Condition Name is required');
      }
      if (!c.conditionTarget || Number(c.conditionTarget) === 0) {
        (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".conditions.").concat(i, ".conditionTarget"), 'Target Share is required');
      }
    }
  });
  if (conditions.length > 1) {
    var totalConditionTarget = conditions.reduce(function (acc, currCondition) {
      return currCondition.conditionTarget ? acc + Number(currCondition.conditionTarget) : acc;
    }, 0.0);
    if (totalConditionTarget !== 100.0) {
      (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".conditions.0.conditionTarget"), "Target Shares must add up to 100% (currently ".concat(totalConditionTarget, "%)"));
    }
  }
  if (!errorIndex.startsWith('default')) {
    if (!branch.branchName) {
      (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".branchName"), 'Branch Name is required');
    }
    if (!branch.formulaId) {
      (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".formulaId"), 'Formula selection is required');
    }
    if (!branch.formulaCompareType) {
      (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".formulaCompareType"), 'Comparison type selection is required');
    }
    if (!branch.formulaCompareValue) {
      (0, _set2["default"])(errors, "branchedCompletionConfig.".concat(errorIndex, ".formulaCompareValue"), 'Comparison value is required');
    }
  }
}